import { FONT_SIZE_LARGE } from 'd2/constants/fonts'
import { ICON_BUTTON_WIDTH, POPOVER_PAPER_HEIGHT } from '../constants'
import { SPACING } from 'd2/constants'
import { px } from 'd2/utils/style'
import makeStyles from 'd2/hooks/tss/makeStyles'
import type { MergedThemes } from 'd2/types'

const styles = (theme: MergedThemes) => ({
  iconButton: {
    fontSize: px(FONT_SIZE_LARGE),
    width: px(ICON_BUTTON_WIDTH),
  },
  popoverPaper: {
    overflowY: 'hidden',
  },
  sliderContainer: {
    height: px(POPOVER_PAPER_HEIGHT),
    padding: `${px(SPACING)} 0`,
    width: px(ICON_BUTTON_WIDTH),
  },
  sliderRail: {
    backgroundColor: theme.palette.grey['500'],
  },
  sliderRoot: {
    width: px(1),
  },
  sliderThumb: {
    backgroundColor: theme.branding?.secondaryColor,
  },
  sliderTrack: {
    backgroundColor: theme.branding?.secondaryColor,
  },
} as const)

export default makeStyles({
  name: 'VolumeButton',
})(styles)
